import React from 'react';

const FixtureDate = ({data}) => {
    return (
        <div className="fixture-date">
            <p>{data.date} - FINAL</p>
        </div>
    );
};

export default FixtureDate;
